var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg62B0B19B53E85F79Fe3374C5ChillReheat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 131,
    viewBox: "0 0 154 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5332 128.686H146.541",
    stroke: "#85E5C6",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5742 40.6694C22.5742 32.4536 29.2344 25.7933 37.4503 25.7933H149.02C150.39 25.7933 151.5 26.9034 151.5 28.2727V112.57C151.5 113.939 150.39 115.05 149.02 115.05H25.0536C23.6843 115.05 22.5742 113.939 22.5742 112.57V40.6694Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.9707,
    y: 40.6694,
    width: 69.4215,
    height: 59.5041,
    rx: 2,
    fill: "#85E5C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4336 40.6694H102.392C103.497 40.6694 104.392 41.5649 104.392 42.6694V98.1736C104.392 99.2781 103.497 100.174 102.392 100.174H99.4336V40.6694Z",
    fill: "#03514E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0366 92.7355L47.3672 92.7355",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7227 85.2975C64.7227 83.9282 65.8327 82.8182 67.202 82.8182H78.359C79.7283 82.8182 80.8384 83.9282 80.8384 85.2975V90.2562H64.7227V85.2975Z",
    fill: "#03514E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4838 85.2975C63.4838 82.5589 61.2637 80.3389 58.5251 80.3389C55.7865 80.3389 53.5664 82.5589 53.5664 85.2975V90.2562H63.4838V85.2975Z",
    fill: "#FF621C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4512 121.248C37.4512 122.617 38.5612 123.727 39.9305 123.727H44.8892C46.2585 123.727 47.3685 122.617 47.3685 121.248V118.289C47.3685 117.185 46.4731 116.289 45.3685 116.289H39.4512C38.3466 116.289 37.4512 117.185 37.4512 118.289V121.248Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.707 121.248C126.707 122.617 127.817 123.727 129.186 123.727H134.145C135.514 123.727 136.624 122.617 136.624 121.248V118.289C136.624 117.185 135.729 116.289 134.624 116.289H128.707C127.602 116.289 126.707 117.185 126.707 118.289V121.248Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 116.311,
    y1: 28.2727,
    x2: 116.311,
    y2: 113.81,
    stroke: "#03514E",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.103 105.132C141.841 105.132 144.061 102.912 144.061 100.174L124.227 100.174L124.227 105.132L139.103 105.132Z",
    fill: "#85E5C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.227 41.9091V56.7851H144.061V46.8677C144.061 44.1291 141.841 41.9091 139.103 41.9091H124.227Z",
    fill: "#85E5C6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.103 70.4215C139.103 73.1601 136.883 75.3802 134.144 75.3802C131.406 75.3802 129.186 73.1601 129.186 70.4215C129.186 67.6829 131.406 65.4628 134.144 65.4628C136.883 65.4628 139.103 67.6829 139.103 70.4215Z",
    fill: "#FF621C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.342 89.0165C140.342 92.4398 137.567 95.2149 134.144 95.2149C130.72 95.2149 127.945 92.4398 127.945 89.0165C127.945 85.5933 130.72 82.8182 134.144 82.8182C137.567 82.8182 140.342 85.5933 140.342 89.0165Z",
    fill: "#FF621C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4043 6.9447L20.4737 18.7363",
    stroke: "#FF621C",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2891 1L29.7783 15.461",
    stroke: "#FF621C",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.0663L14.5814 27.1496",
    stroke: "#FF621C",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg62B0B19B53E85F79Fe3374C5ChillReheat);
export default __webpack_public_path__ + "static/media/62b0b19b53e85f79fe3374c5_chill-reheat.4a24f7d1764d2b46483a0ecfe97af3f6.svg";
export { ForwardRef as ReactComponent };